import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CurrencyExchangeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"currency_exchange"}/>
}
